import {
	INDEX_SEARCH_KEYS
} from 'constants';

export function inSearch(w, searchText){
	return buildSearchSpace(w)
		.indexOf(searchText) >= 0;
}

export function applySearch(searchText, works, artists){
	if (!searchText){
		return artists.concat(works);
	}
	searchText = searchText.toLowerCase();

	return artists.filter(a =>
			a.name.toLowerCase().indexOf(searchText) >= 0
		).concat(
			works.filter(
				w => inSearch(w, searchText)
			)
		);
}

export function searchWork(work, searchText){
	if (!searchText === ''){
		return true;
	}
	let space = [];
	if (work.name){
		space.push(work.name.toLowerCase());
	}
	space.push(buildSearchSpace(work));
	return space.join(' ').toLowerCase()
		.indexOf(searchText.toLowerCase()) >= 0;
}

export function buildSearchSpace(w){
	return INDEX_SEARCH_KEYS
		.map(k => w[k])
		.join(' ')
		.toLowerCase();
}